import { render, staticRenderFns } from "./FormBackButton.vue?vue&type=template&id=5a908493&scoped=true&"
import script from "./FormBackButton.vue?vue&type=script&lang=ts&"
export * from "./FormBackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a908493",
  null
  
)

export default component.exports